// extracted by mini-css-extract-plugin
export var wrapper = "Datenschutzerklärung-module--wrapper--bxkaK";
export var content = "Datenschutzerklärung-module--content--xG2GF";